"use client";
import { createContext, useState, useContext } from "react";
import { useRouter } from "next/navigation"; 


export const BlogContext = createContext();


export function BlogProvider({ children }) {
  const [blog, setSelectedBlog] = useState(null);
  const router = useRouter();


  const viewBlog = (blog) => {
    setSelectedBlog(blog); 
    const new_title= blog.heading.split(" ").join("-")
    router.push(`/blog/${new_title}`);
  };

  return (
    <BlogContext.Provider value={{ blog, viewBlog }}>
      {children}
    </BlogContext.Provider>
  );
}


export function useBlogContext() {
  return useContext(BlogContext);
}
